import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // This hook ensures that on every page navigation, the user is scrolled to the top.
    // The check for `window` ensures this code only runs in a browser environment,
    // making it safe for server-side prerendering.
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
    }
  }, [location]);
};

export default useScrollToTop;